import { checkIsSplitShippedToInventory } from '../order/is-item-split-shipped';
export const hasSplitShippedToInventory = item => {
  if (Array.isArray(item)) {
    if (Array.isArray(item[0])) {
      return item.some(subArray => Array.isArray(subArray) && subArray.some(i => checkIsSplitShippedToInventory(i)));
    } else {
      return item.some(i => 'splitShippedType' in i && checkIsSplitShippedToInventory(i));
    }
  }
  return false;
};